import {
  // SET_ACCOUNT,
  SET_SCHOOL,
  SET_SUGGESTIONS,
  ADD_NEW_SUGGESTION,
  EDIT_SUGGESTION,
  DELETE_SUGGESTION,
  CLEAN_NEW_SUGGESTIONS,
  UPDATE_SCHOOL_DETAILS,
  UPDATE_SCHOOL_INVITE,
  UPDATE_COURSE_DETAIL,
  REMOVE_STUDENTS_FROM_COURSE,
  UPDATE_COURSE_INTEGRATIONS,
  SET_PROVIDERS,
  UPDATE_PROVIDERS,
  MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED,
} from '../mutation-types';

import { EventBus } from 'utils/event-bus';
import adminServices from 'services/admin/adminServices';
import accountService from 'services/account';

// Example, delete after first created
//   export const setAccount = ({ commit }, account) => {
//     commit(SET_ACCOUNT, account);
//   };

const emitToastError = (message, type) => {
  const toast = {
    type,
    message,
    time: 5000,
  };
  EventBus.$emit('createToast', toast);
  return null;
};

export const getSchoolDetails = ({ commit }, schoolID) => {
  return adminServices.getSchool(schoolID).then((res) => {
    commit(SET_SCHOOL, res.data);
    return res.data;
  });
};

export const setSchool = ({ commit }, data) => {
  commit(SET_SCHOOL, data);
};

export const updateCurrentSchoolInvite = ({ commit }, invite_fields) => {
  commit(UPDATE_SCHOOL_INVITE, invite_fields);
};

export const updateSchoolDetails = ({ commit }, data) => {
  commit(UPDATE_SCHOOL_DETAILS, data);
};

export const getSchoolUserDetails = (_, { schoolID, userID }) => {
  return adminServices
    .getUserDetailsOfSchool(schoolID, userID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getUserDetails = (_, { userID }) => {
  return adminServices
    .getUserDetails(userID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getAdminUsersOfSchool = (_, code) => {
  return adminServices
    .getAdminUsersOfSchool(code)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const updateSchoolUserAdminRole = (_, { schoolID, userID, payload }) => {
  return adminServices
    .updateSchoolUserAdminRole(schoolID, userID, payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSchoolUserCourses = (_, { schoolID, userID }) => {
  return adminServices
    .getSchoolUserCourses(schoolID, userID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getUserCourses = (_, { userID }) => {
  return adminServices
    .getUserCourses(userID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const SOCKET_addNewSuggestion = ({ commit, getters }, suggestion) => {
  if (getters.getCurrentSchool.id === suggestion.school_id) {
    EventBus.$emit('has-new-suggestions');
    commit(ADD_NEW_SUGGESTION, suggestion);
  }
};


export const addDraftSuggestion = ({ commit }, suggestion) => {
  commit(ADD_NEW_SUGGESTION, suggestion);
};

export const SOCKET_editSuggestion = ({ commit, getters }, suggestion) => {
  if (getters.getCurrentSchool.id === suggestion.school_id)
    commit(EDIT_SUGGESTION, suggestion);
};

export const SOCKET_deleteSuggestion = ({ commit, getters }, suggestion) => {
  if (getters.getCurrentSchool.id === suggestion.school_id)
    commit(DELETE_SUGGESTION, suggestion);
};

export const SOCKET_changeUserRole = (_, user) => {
  EventBus.$emit('role-has-changed', user);
};

export const SOCKET_deleteUserFromSchool = (_, user) => {
  EventBus.$emit('removed_student_from_school', user);
};

export const SOCKET_deleteCourseFromSchool = (_, course) => {
  EventBus.$emit('removed_course_from_school', course);
};

export const setSuggestions = ({ commit }, school_id) => {
  return adminServices
    .getSuggestions(school_id)
    .then((res) => {
      if (res.data) {
        commit(SET_SUGGESTIONS, res.data);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const cleanNewSuggestion = ({ commit }) => {
  commit(CLEAN_NEW_SUGGESTIONS);
};

export const getSitesOfSchool = (_, schoolID) => {
  return adminServices
    .getSitesOfSchool(schoolID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const updateUserSchoolSite = (_, { schoolID, userID, payload }) => {
  return adminServices
    .updateUserSchoolSite(schoolID, userID, payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

// Integrations
export const getEdlinkMetadata = (_, { schoolID }) => {
  return adminServices
    .getEdlinkMetadata(schoolID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};
export const getSsoMetadata = (_, { redirect_uri, integration_id }) => {
  return adminServices
    .getSsoMetadata(redirect_uri, integration_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoCourseMetadata = (_, { course_id, redirect_uri, integration_id }) => {
  return adminServices
    .getSsoCourseMetadata(course_id, redirect_uri, integration_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getAccessToken = (_, { code, redirect_uri }) => {
  return adminServices
    .getAccessToken(code, redirect_uri)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const refreshAccessToken = () => {
  return adminServices
    .refreshAccessToken()
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getEdlinkIntegrations = () => {
  return adminServices
    .getEdlinkIntegrations()
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoProviders = ({ commit }) => {
  return adminServices
    .getSsoProviders()
    .then((res) => {
      if (res.data) {
        commit(SET_PROVIDERS, res.data);
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoCourseProviders = async ({ commit }, course_id) => {
  const { data, status } = await adminServices.getSsoCourseProviders(course_id);
  if (!data || status !== 200) {
    return console.error('Something happens with providers');
  }
  commit(SET_PROVIDERS, data);
  return data;
};

export const getEdlinkIntegrationsSchool = (school_id) => {
  return adminServices
    .getEdlinkIntegrationsSchool(school_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const generateSsoTokens = (_, payload) => {
  return adminServices
    .generateSsoTokens(payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    });
};


export const generateSubscriptionSsoTokens = ({ dispatch }, payload) => {
  return adminServices
    .generateSubscriptionSsoTokens(payload)
    .then((res) => {
      if (res.data) {
        return accountService.completeInfo().then(({ data }) => {
          dispatch('setAccount', data);
          return data;
        });
      }
      else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    });
};

export const getSsoIntegration = (_, payload) => {
  return adminServices
    .getSsoIntegration(payload.course_id, payload.integration_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getEdlinkSchoolProviders = (_, { schoolID }) => {
  return adminServices
    .getEdlinkSchoolProviders(schoolID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoCourses = (_, payload) => {
  return adminServices
    .getSsoCourses(payload.course_id, payload.integration_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const associateEdlinkIntegrationWithSchool = (_, payload) => {
  return adminServices
    .associateEdlinkIntegrationWithSchool(payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoCourseStudents = (_, payload) => {
  return adminServices
    .getSsoCourseStudents(payload.integration_id, payload.course_id, payload.edlink_course_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoCourseTeachers = (_, payload) => {
  return adminServices
    .getSsoCourseTeachers(payload.integration_id, payload.course_id, payload.edlink_course_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getCourseCategories = (_, payload) => {
  const { integration_id, course_id, edlink_course_id } = payload;
  return adminServices.getCourseCategories(integration_id, course_id, edlink_course_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getEdlinkSchoolIntegrationCourses = (_, { schoolID, integrationID, filters }) => {
  Object.keys(filters).forEach((key) => {
    filters[key] = encodeURIComponent(filters[key]);
  });
  return adminServices
    .getEdlinkSchoolIntegrationCourses(schoolID, integrationID, filters)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const disconnectSsoIntegration = ({ dispatch }, { integration_id }) => {
  return adminServices
    .disconnectSsoIntegration(integration_id).then(() => {
      return accountService.completeInfo().then(({ data }) => {
        dispatch('setAccount', data);
        return data;
      });
    }).catch(() => {
      EventBus.$emit('toast-msg', 'Error disconnecting the account');
    });
};

export const disconnectSsoCourseIntegration = ({ dispatch, getters }, { course_id, integration_id }) => {
  return adminServices
    .disconnectSsoCourseIntegration(course_id, integration_id).then(({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        dispatch('fetchCourseDetails', course_id);
      }
    });
};

export const disconnectStudentSsoIntegration = ({ dispatch, getters }, { course_id, integration_id }) => {
  return adminServices
    .disconnectStudentSsoIntegration(course_id, integration_id).then(({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        dispatch('fetchCourseDetails', course_id);
      }
    });
};

export const importSsoCourseStudents = (
  { commit, getters },
  { integration_id, course_id, edlink_course_id, edlink_course_name, students }
) => {
  return adminServices.importSsoCourseStudents(integration_id, course_id, edlink_course_id, students, edlink_course_name).then((res) => {
    if (getters.getCourseDetail.id === course_id) {
      commit(UPDATE_COURSE_DETAIL, { edlink_integrations: res.data });
      return res.data;
    }
  });
};

export const unsyncIntegrationCourse = ({ commit, getters }, { course_id, integration_id, remove_students }) => {
  adminServices.disconnectSsoCourseIntegration(course_id, integration_id, { remove_students }).then(
    ({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        commit(UPDATE_COURSE_INTEGRATIONS, integration_id);
        const { deleted_students } = data;
        if (deleted_students.length) {
          commit(REMOVE_STUDENTS_FROM_COURSE, deleted_students);
        }
      }
    });
};

export const updateProviders = ({ commit }, payload) => {
  commit(UPDATE_PROVIDERS, payload);
};

export const getEdlinkProviders = () => {
  return adminServices
    .getEdlinkProviders()
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Error getting providers', 'Error');
      }
    })
    .catch(emitToastError('Error getting providers', 'Error'));
};

export const getEdlinkSchoolIntegrationCoursesFilters = (_, { schoolID, integrationID }) => {
  return adminServices
    .getEdlinkSchoolIntegrationCoursesFilters(schoolID, integrationID)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const unsyncProviderStudentFromCourse = ({ commit, getters }, { course_id, integration_id, edlink_course_id, student_ids }) => {
  return adminServices.unsyncProviderStudentFromCourse(course_id, integration_id, edlink_course_id, { student_ids }).then(
    ({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        const { deleted_students } = data;
        if (deleted_students.length) {
          commit(REMOVE_STUDENTS_FROM_COURSE, deleted_students);
        }
      }
    });
};

export const sendEmailToAdmin = (_, { integration_name, admin_email, school_name }) => {
  return adminServices
    .sendEmailToAdmin(integration_name, admin_email, school_name)
    .catch(() => emitToastError('Error sending email to Admin', 'Error'));
};

export const createSsoCourseAssignment = ({ commit }, { course_id, integration_id, edlink_course_id, activity_type, activity_id, payload }) => {
  return adminServices
    .createSsoCourseAssignment(course_id, integration_id, edlink_course_id, activity_type, activity_id, payload)
    .then(({ data }) => {
      if (activity_type === 'written') {
        commit(MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED, activity_id);
      }
      return data;
    })
    .catch(() => {
      if (payload.provider_name === 'Microsoft' && !payload.due_date)
        emitToastError('Microsoft Teams requires that all assignments have a due date.', 'Error');
      else
        emitToastError('Error creating the assignment', 'Error');
    });
};

export const updateSsoCourseAssignment = (_, { course_id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id, payload }) => {
  return adminServices
    .updateSsoCourseAssignment(course_id, integration_id, edlink_course_id, activity_type, activity_id, assignment_id, payload)
    .then((data) => {
      return data;
    })
    .catch(() => emitToastError('Error updating the assignment', 'Error'));
};

export const getSsoCoursesFromLms = (_, payload) => {
  return adminServices
    .getSsoCoursesFromLms(payload.integration_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const getSsoCourseStudentsFromLms = (_, payload) => {
  return adminServices
    .getSsoCourseStudentsFromLms(payload.integration_id, payload.edlink_course_id)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const createSsoCoursesFromLms = (_, { integration_id, payload }) => {
  return adminServices
    .createSsoCoursesFromLms(integration_id, payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    });
};

export const addUserToClassesSharingRule = (_, { integration_id, payload }) => {
  return adminServices
    .addUserToClassesSharingRule(integration_id, payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};

export const removeUserFromClassesSharingRule = (_, { integration_id, payload }) => {
  return adminServices
    .removeUserFromClassesSharingRule(integration_id, payload)
    .then((res) => {
      if (res.data) {
        return res.data;
      } else {
        this.emitToastError('Hmm... something went wrong. Please refresh the page or try again.', 'error');
      }
    })
    .catch(emitToastError);
};


// WEBPACK FOOTER //
// ./src/app/store/actions/adminPortal.js